APPS.shows.archive = (function(){
	var _showId;
	
	
    var show = function(id){
	    APP.getView().showChildView('mainRegion',Backbone.Radio.channel('views').request('loading'))
	    
        $.when( Backbone.Radio.channel('entities').request('episodes',{showId:id}) ).done(function(data){ 
	        APP.getView().showChildView('mainRegion', new pageView({
                collection:data
            }) )
            
            window.document.title = data.state.showDetails.title+" Archive";
            if(typeof ga != "undefined"){ ga('send','pageview',{ title:data.state.showDetails.title+" Archive" }) }
			if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': data.state.showDetails.title+" Archive" }); }
            if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, data.state.showDetails.title+" Archive", '0', false, true); }
        })
    }
    

    
    
   	// THE PAGE
        var pageView = Marionette.View.extend({
             template:"#tmpl-shows-archive"
            ,className:"page_archive mt8"
            ,regions:{
                program:{
                    el: '#programContainer'
                }
                ,episodes:{
                    el: '#episodesContainer'
                }
            }
            ,templateContext:function(){
	            var sorted = [];
                _.each(this.collection.models,function(model){
					var date = model.attributes.assets[0].airdate.split('-');
					//By default, months have leading 0s, which causes 10 to be before 01,
					//	so force into an int to strip leading zeros
					date[1] = +date[1];
					if(!sorted[date[0]]){ sorted[date[0]] = []; } //year
					if(!sorted[date[0]][date[1]]){ sorted[date[0]][date[1]] = []; } //month
					sorted[date[0]][date[1]].push(model); //day
	            })
	            
				return {
		             sorted:sorted
		            ,showId:this.collection.showId 
		            ,showTitle:this.collection.state.showDetails.title
		            ,showSlug:this.collection.state.showDetails.slug
	            }
            }
            ,events:{
	            "click .yearTrigger span":function(e){
		            this.$el.find('.yearsContainer').find('span').removeClass('current')
		            $(e.currentTarget).addClass('current')
		            
					this.$el.find('.episodeContainer').hide()
					this.$el.find('.monthsContainer').hide()
					this.$el.find("#months"+$(e.currentTarget).html()).show()
	            }
	            ,"click .monthTrigger":function(e){
		            this.$el.find('.monthsContainer').find('span').removeClass('current')
		            $(e.currentTarget).addClass('current')
		            
		            this.$el.find('.episodeContainer').hide()
					this.$el.find("#month"+$(e.currentTarget).data('key')).show()
	            }
	            
            }
            ,onAttach:function(){
	            //start the page off with the most recent month open
	            this.$el.find('.yearsContainer li').last().children('span').trigger('click')
	            this.$el.find('.monthsContainer:visible li').last().children('span').trigger('click')
            }
        })    
    

    return {
        show:show
    }
})();